module.exports = __webpack_public_path__ + "img/pantalla1-2.5d71cc71.png";